export const heatCoeficientPerMonth = [
  1, 1, 1, 0.82, 0.82, 0.69, 0.69, 0.69, 0.82, 0.82, 1, 1,
];

export const copPerMonth = [
  1, 1, 1, 0.82, 0.82, 0.69, 0.69, 0.69, 0.82, 0.82, 1, 1,
];
